(function () {
  if (window.__cscVariantLinePropertiesInstalled) return;
  window.__cscVariantLinePropertiesInstalled = true;

  var CART_ADD_JSON_RE = /\/cart\/add\.js(?:[?#].*)?$/;
  var PRODUCT_OPTION_RE = /^options\[(.+)\]$/i;

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') === 0;
  }

  function hasSelleasyProductSurface() {
    return !!document.querySelector([
      '.lb-upsell-product-page-card',
      '.lb-upsell-ppa-card-cont',
      'lb-upsell-product-page-addon',
      'lb-addon',
      'lb-upsell-widget',
      'lb-product-card',
    ].join(','));
  }

  function cleanValue(value) {
    return String(value || '').replace(/\s+-\s+Unavailable\s*$/i, '').trim();
  }

  function propertyNameForOption(optionName) {
    var normalized = String(optionName || '').toLowerCase();

    if (normalized.indexOf('body') !== -1) return 'Body type';
    if (normalized.indexOf('year') !== -1) return 'Year';

    return null;
  }

  function readOptionValue(input) {
    if (!input) return '';

    if (input.tagName === 'SELECT') {
      var selected = input.options[input.selectedIndex];
      return cleanValue(input.value || (selected && selected.text));
    }

    return cleanValue(input.value);
  }

  function getSelectedVehicleProperties() {
    var properties = {};
    var controls = document.querySelectorAll('select[name^="options["], input[name^="options["]:checked');

    controls.forEach(function (control) {
      var match = String(control.name || '').match(PRODUCT_OPTION_RE);
      if (!match) return;

      var propertyName = propertyNameForOption(match[1]);
      var value = readOptionValue(control);

      if (!propertyName || !value || value.toLowerCase() === 'default title') return;

      properties[propertyName] = value;
    });

    return properties;
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getSelectedSourceVariantId() {
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var variantInput = productForm && productForm.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;

    if (!variantId) {
      variantId = new URLSearchParams(window.location.search).get('variant');
    }

    return cleanValue(variantId);
  }

  function addSourceProperties(properties) {
    var sourceVariantId = getSelectedSourceVariantId();
    var sourceHandle = getProductHandle();

    if (sourceVariantId) properties._csc_source_variant_id = sourceVariantId;
    if (sourceHandle) properties._csc_source_handle = sourceHandle;

    return properties;
  }

  function shouldPatchCartAdd(url, body) {
    if (!isProductPage() || !hasSelleasyProductSurface()) return false;
    if (!url || !CART_ADD_JSON_RE.test(url)) return false;
    if (typeof body !== 'string' || body.indexOf('"items"') === -1) return false;

    return true;
  }

  function patchCartAddBody(url, body) {
    if (!shouldPatchCartAdd(url, body)) return body;

    var vehicleProperties = addSourceProperties(getSelectedVehicleProperties());
    if (!vehicleProperties.Year && !vehicleProperties['Body type']) return body;

    var payload;
    try {
      payload = JSON.parse(body);
    } catch (error) {
      return body;
    }

    if (!payload || !Array.isArray(payload.items)) return body;

    payload.items = payload.items.map(function (item) {
      if (!item || typeof item !== 'object') return item;

      return Object.assign({}, item, {
        properties: Object.assign({}, item.properties || {}, vehicleProperties),
      });
    });

    return JSON.stringify(payload);
  }

  function safelyPatchCartAddBody(url, body) {
    try {
      return patchCartAddBody(url, body);
    } catch (error) {
      return body;
    }
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;

    return '';
  }

  function wrapFetch(nativeFetch) {
    if (typeof nativeFetch !== 'function') return nativeFetch;
    if (nativeFetch.__cscVariantLinePropertiesWrapped) return nativeFetch;

    var wrappedFetch = function (input, init) {
      var url = requestUrl(input);
      var nextInit = init;

      if (nextInit && typeof nextInit.body === 'string') {
        var patchedBody = safelyPatchCartAddBody(url, nextInit.body);

        if (patchedBody !== nextInit.body) {
          nextInit = Object.assign({}, nextInit, { body: patchedBody });
        }
      }

      return nativeFetch.call(this, input, nextInit);
    };

    wrappedFetch.__cscVariantLinePropertiesWrapped = true;
    return wrappedFetch;
  }

  if ('fetch' in window) {
    try {
      var currentFetch = wrapFetch(window.fetch);
      var fetchDescriptor = Object.getOwnPropertyDescriptor(window, 'fetch');

      if (!fetchDescriptor || fetchDescriptor.configurable) {
        Object.defineProperty(window, 'fetch', {
          configurable: true,
          enumerable: fetchDescriptor ? fetchDescriptor.enumerable : true,
          get: function () {
            return currentFetch;
          },
          set: function (nextFetch) {
            currentFetch = wrapFetch(nextFetch);
          },
        });
      } else {
        window.fetch = currentFetch;
      }
    } catch (error) {
      window.fetch = wrapFetch(window.fetch);
    }
  }

  if (window.XMLHttpRequest) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__cscVariantLinePropertiesUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function (body) {
      if (typeof body === 'string') {
        body = safelyPatchCartAddBody(this.__cscVariantLinePropertiesUrl, body);
      }

      return nativeSend.call(this, body);
    };
  }
})();
